export default __webpack_public_path__ + "static/media/employee_testi.7b8f85ca.png";